module.exports = {
  "level1": {
    "name": "Tên thật",
    "address": "Chi tiết địa chỉ cư trú hiện tại",
    "bank_number": "Tài khoản ngân hàng",
    "wc": "OK",
    "name_nodata": "Không được để trống tên",
    "id_card_nodata": "Không được để trống số ID",
    "address_nodata": "Không được để trống địa chỉ",
    "bank_number_nodata": "Không được để trống tài khoản ngân hàng",
    "input-username": "Vui lòng nhập tên thật của bạn",
    "zjhm": "Số ID",
    "input-idcard": "Vui lòng nhập số ID",
    "input-address": "Vui lòng điền địa chỉ",
    "zjlx": "Loại ID hợp lệ",
    "qxzzjlx": "Vui lòng chọn loại ID",
    "sfz": "Thẻ ID",
    "hz": "Hộ chiếu",
    "jsz": "Bằng lái xe",
    "khh": "Tài khoản đang mở",
    "qsrkhh": "Vui lòng nhập ngân hàng",
    "yhkh": "Tài khoản ngân hàng",
    "qsryhkh": "Vui lòng nhập số tài khoản ngân hàng",
    "gjlb": "Danh sách các quốc gia",
    "qxzgjlb": "Vui lòng chọn Quốc gia / Vùng"
  },
  "my": {
    "mqrcode": "Mã QR của tôi",
    "as": "Cài đặt",
    "pc": "Chứng chỉ sơ cấp",
    "ac": "Chứng chỉ cao cấp",
    "ms": "Chia sẻ",
    "me": "Thu nhập của tôi",
    "zsr": "Tổng doanh thu",
    "mp": "Khuyến mại của tôi",
    "yqhy": "Mời bạn bè",
    "ar": "Hồ sơ",
    "hc": "Trung tâm trợ giúp",
    "nodata": "Không có dữ liệu",
    "med": "Chia nhỏ thu nhập",
    "aes": "Thu nhập tích lũy (USDT)",
    "one": "Thế hệ thứ nhất     ",
    "two": "Thế hệ thứ hai",
    "three": "Thế hệ thứ ba",
    "four": "Thế hệ thứ tư",
    "ones": "Người thế hệ thứ nhất",
    "twos": "Người thế hệ thứ hai",
    "threes": "Người thế hệ thứ ba",
    "fours": "Người thế hệ thứ tư",
    "promotion": "Số lượng khuyến mại",
    "customers": "Thu nhập của tôi",
    "wdzc": "Tài sản của tôi",
    "wdzc1": "Tài sản của tôi",
    "wyfx": "Chia sẻ",
    "wdsy": "Thu nhập của tôi",
    "wdtg": "Khuyến mại của tôi",
    "zhjl": "Hồ sơ",
    "zxkf": "Liên hệ chúng tôi",
    "wdxx": "Tin nhắn của tôi",
    "smrz":"Xác thực KYC",
    "sfyz":"Xác thực KYC"
  },
  "footer": {
    "home": "Trang chủ",
    "quotation": "Thị trường",
    "currency": "Trao đổi",
    "lever": "Hợp đồng",
    "my": "tài khoản",
    "lc": "Lãi USDT đã thu được"
  },
  "index": {
    "wdzc": "Tài sản của tôi (USDT)",
    "dl": "đăng nhập",
    "zxkf": "Liên hệ chúng tôi",
    "increase": "Danh sách tiền lãi",
    "usercenter": "Trung tâm cá nhân",
    "security": "Trung tâm Bảo mật",
    "address": "Địa chỉ rút tiền",
    "aboutus": "Về chúng tôi",
    "vol": "Khối lượng 24 giờ",
    "kjcb": "Tiền ký quỹ",
    "zcbz": "BTC, USDT...",
    "logout":"đăng xuất",
    "language":"Ngôn ngữ"
  },
  "transaction": {
    "buy": "Mua",
    "sell": "Bán",
    "pwd": "Mật khẩu giao dịch",
    "inputnum": "Nhập số lượng",
    "limit": "Giới hạn",
    "avaiable": "Khả dụng",
    "turnover": "Giao dịch",
    "handicap": "Điều bất lợi",
    "number": "Số lượng",
    "nonumber": "Số lượng còn tồn",
    "numbered": "Số lượng đã hoàn tất",
    "price": "Giá",
    "marketprice": "Giá thị trường",
    "cancel": "Hủy",
    "time": "Thời gian",
    "nomore": "Không còn thêm",
    "nodata": "Không có hồ sơ",
    "getmore": "Tải thêm",
    "mycommission": "Giao dịch ủy thác",
    "currentbuy": "Lệnh hiện thời (Mua)",
    "currentsell": "Lệnh hiện thời (Bán)    ",
    "his": "Lịch sử (Hoàn tất)",
    "currency": "Tiền tệ",
    "option": "Vận hành",
    "wtime": "Thời gian hoàn thành",
    "wnumber": "Số lượng đã hoàn thành",
    "wprice": "Mức giá hoàn thành"
  },
  "mk": {
    "high": "Cao",
    "low": "Thấp",
    "vol": "Khối lượng 24 giờ",
    "newPrice": "Giá mới nhất",
    "product": "Sản phẩm",
    "name":"Tên",
    "rank": "Danh sách tiền lãi"
  },
  "deals": {
    "issue_time": "Thời gian công bố",
    "issue_number": "Mã số phát hành",
    "white_book": "Sách trắng",
    "weburl": "Trang web chính thức",
    "video_url": "Video",
    "introduction": "Thông tin",
    "onhand": "1 lô =",
    "position": "Vị thế",
    "leverorder": "Lệnh đòn bẩy",
    "leverposition": "Vị thế đòn bẩy",
    "inputprice": "Nhập giá",
    "inputmul": "Nhập hệ số",
    "selectmul": "Chọn hệ số",
    "onehand": "1 lô =",
    "hand": "Lô giao dịch",
    "marketval": "Giá trị thị trường",
    "bond": "Trái phiếu",
    "balance": "Số dư",
    "type": "Loại",
    "risk": "Tỷ lệ rủi ro",
    "total": "Lợi nhuận tổng",
    "onekey": "Thanh khoản một lần nhấp chuột",
    "makemore": "(Dài hạn)",
    "makeless": "(Ngắn hạn)",
    "current": "Lệnh mở",
    "all": "Tất cả các",
    "weing": "Hoa hồng",
    "tding": "Đang giao dịch",
    "ping": "Đang đóng",
    "pied": "Đã đóng",
    "ceiled": "Đã rút",
    "weprice": "Giá hoa hồng",
    "oprice": "Giá mở cửa",
    "nowprice": "Giá hiện thời",
    "zyprice": "Giá chốt lãi",
    "zsprice": "Giá cắt lỗ",
    "canbond": "Ký quỹ khả dụng",
    "optime": "Thời gian mở cửa",
    "pgtime": "Thời gian đóng cửa",
    "znum": "Số tiền đã chuyển đổi",
    "gprice": "Phí giao dịch qua đêm",
    "pcang": "Đóng",
    "revoke": "Rút tiền",
    "fee": "Phí",
    "you": "Giá thị trường tối ưu"
  },
  "assets": {
    "copy": "Sao chép",
    "avaiable": "Khả dụng",
    "lock": "Đóng băng",
    "conversion": "Chuyển đổi",
    "exact": "Tài khoản giao dịch",
    "num": "Số lượng",
    "time": "Thời gian",
    "all": "Tất cả các",
    "canuse": "Khả dụng",
    "cmoney": "Tiền ký quỹ",
    "tmoney": "Rút tiền",
    "caddress": "Địa chỉ tiền ký quỹ",
    "copyaddress": "Sao chép địa chỉ",
    "taddress": "Địa chỉ rút tiền",
    "taddressm": "Vui lòng nhập địa chỉ rút tiền",
    "rate": "Phí",
    "dnum": "Số tiền đến",
    "more": "Tải thêm",
    "nodata": "Không có hồ sơ",
    "yczc": "Ẩn tài sản bạn không có",
    "total":"Chuyển đổi tài sản (USDT)"
  },
  "td": {
    "drecord": "Bản ghi lệnh",
    "orecord": "Lệnh đã hoàn tất",
    "filter": "Bộ lọc",
    "dstatus": "Trạng thái lệnh",
    "nofinish": "Hoàn tác",
    "finished": "Đã hoàn tất",
    "ceiled": "Đã hủy",
    "reset": "Đặt lại",
    "confirm": "OK",
    "time": "Thời gian",
    "num": "Số lượng",
    "price": "Giá",
    "ptime": "Thời gian đặt lệnh",
    "receiver": "Người hưởng",
    "open": "Tài khoản đang mở",
    "pwd": "Mật khẩu giao dịch",
    "ppwd": "Vui lòng nhập mật khẩu giao dịch",
    "sure": "OK",
    "realName": "Tên thật",
    "pnum": "Vui lòng nhập số tiền",
    "buyNum": "Số lượng mua",
    "currency": "Tiền tệ"
  },
  "fat": {
    "ceil": "Hủy",
    "num": "Số lượng",
    "submit": "Đặt một lệnh",
    "pwd": "Mật khẩu giao dịch",
    "ppwd": "Vui lòng nhập mật khẩu giao dịch",
    "sure": "Xác nhận",
    "auHigh": "Chứng chỉ cao cấp"
  },
  "auth": {
    "bh": "Đã bị từ chối",
    "mycenter": "Trung tâm cá nhân",
    "test": "KYC",
    "testing": "Đang xem xét",
    "name": "Tên",
    "account": "Tài khoản",
    "id_card_face": "Vui lòng tải lên mặt trước của thẻ ID\n",
    "id_card_back": "Vui lòng tải lên mặt sau của thẻ ID",
    "updata": "Gửi",
    "updata_again": "Gửi lại   "
  },
  "code": {
    "notice": "Thông báo     "
  },
  "safe": {
    "title": "Bảo mật tài khoản   ",
    "center": "Trung tâm Bảo mật",
    "yysz": "Ngôn ngữ",
    "ssms": "Chế độ nền tối   ",
    "gywm": "Về chúng tôi",
    "lgpwd": "Mật khẩu đăng nhập ",
    "resetpwd": "Chỉnh sửa mật khẩu",
    "paccount": "Số điện thoại di động hoặc hộp thư của bạn",
    "reset": "Sửa đổi",
    "ceil": "Hủy",
    "pcode": "mã xác nhận",
    "sure": "Xác nhận",
    "newPwd": "Đặt lại mật khẩu",
    "ppwd": "Mật khẩu",
    "reppwd": "Mật khẩu lần nữa",
    "repwd": "Đặt lại mật khẩu",
    "zpwd": "Mật khẩu giao dịch"
  },
  "met": {
    "open": "Tên trên tài khoản ngân hàng",
    "bank": "Tài khoản ngân hàng",
    "realname": "Tên thật",
    "save": "Lưu",
    "popen": "Vui lòng nhập tên trên tài khoản ngân hàng",
    "pbank": "Vui lòng nhập ngân hàng và số tài khoản",
    "pname": "Vui lòng nhập tên thật của bạn"
  },
  "ads": {
    "tas": "Địa chỉ rút tiền",
    "address": "Địa chỉ",
    "noads": "Bạn chưa có địa chỉ.",
    "adds": "Địa chỉ",
    "remark": "Chú thích",
    "cel": "Xóa"
  },
  "jc": {
    "ppwd": "Mật khẩu"
  },
  "lg": {
    "welcome": "Chào mừng! Vui lòng đăng nhập",
    "lgtel": "Đăng nhập bằng số điện thoại di động",
    "lgeml": "Đăng nhập bằng email",
    "paccount": "Số điện thoại hoặc Email",
    "ppwd": "Mật khẩu",
    "ppwd2": "Vui lòng xác nhận mật khẩu của bạn",
    "pcode": "mã xác nhận",
    "qsryqm": "Mã mời",
    "noaccount": "Bạn chưa có tài khoản?",
    "register": "Đăng ký",
    "phregister": "Đăng ký bằng số điện thoại di động",
    "emregister": "Đăng ký bằng email",
    "pphone": "số điện thoại",
    "ceil": "Hủy",
    "send": "Nhận CAPTCHA",
    "sure": "OK",
    "email": "địa chỉ email",
    "emtest": "Xác nhận email",
    "pemcode": "mã xác nhận",
    "ppcode": "Vui lòng nhập mã xác nhận của bạn",
    "ftpwd": "Bạn quên mật khẩu?",
    "ptext": "Số điện thoại di động hoặc hộp thư của bạn",
    "yzm": "Mã xác minh",
    "mm": "Mật khẩu",
    "qrmm": "Xác nhận mật khẩu",
    "language":"Ngôn ngữ",
    "qregister":"Đăng ký",
    "lgs":"đăng nhập",
    "ftpwds":"Bạn quên mật khẩu",
    "kjzc": "Liên hệ đăng ký nhanh",
    "kjzc1": "Không thể nhận Captcha?",
    "kjzc2": "Đăng kí nhanh",
    "wyzx": "Tôi đã biết",
    "qtxyxzh": "Quan trọng: Vui lòng điền vào một địa chỉ email hoặc số điện thoại di động hợp lệ, có thể được sử dụng để lấy lại mật khẩu của bạn",
    "next": "Bước tiếp theo"
  },
  "gjrz": {
    "title": "Chứng chỉ cao cấp",
    "t1": "1. Hỗ trợ các ảnh dưới 8MB và định dạng JPG, JPEG hoặc PNG.",
    "t2": "2. Các ảnh tài liệu ID phải rõ ràng và sẽ không bị chỉnh sửa hoặc che khuất. Mã số tài liệu ảnh cá nhân và tên của chủ sở hữu tài liệu phải dễ nhìn.",
    "t3": "3. Các ảnh phải được chụp mà không có bất kỳ vật che đầu nào và không khuyến khích trang điểm khi chup. Các đường nét khuôn mặt trong ảnh phải rõ ràng và dễ nhận biết và không để lộ toàn bộ tay.",
    "t4": "OK",
    "bh": "Đã bị từ chối",
    "shz": "Đang xem xét",
    "shtg": "Đã phê duyệt",
    "sczjz": "Tải lên ảnh ID",
    "sczjzmz": "Tải lên ảnh mặt trước của tài liệu ID",
    "sczjbmz": "Tải lên ảnh mặt sau của tài liệu ID",
    "scgrqmz": "Tải lên các tài liệu ID và chữ ký cá nhân"
  },
  "chongzhi": {
    "title": "Tiền ký quỹ",
    "cbjl": "Hồ sơ tiền ký quỹ",
    "t1": "Số lượng",
    "t2": "Vui lòng nhập số tiền",
    "t3": "diễn tả(Không bắt buộc)",
    "t4": "Vui lòng nhập mô tả",
    "t5": "Ảnh phiếu mua hàng",
    "t6": "OK",
    "t7": "Tên chuỗi",
    "t8": "Mã QR",
    "t9": "Lưu mã QR",
    "t10": "Địa chỉ tiền ký quỹ",
    "t11": "Sao chép",
    "zy": "Quan trọng",
    "tips1": "Vui lòng không nạp bất kỳ tài sản nào không phải bằng đơn vị tiền tệ này vào địa chỉ trên nếu không sẽ không thể truy xuất tài sản",
    "tips2": "1. Khả năng tương thích của ví / nền tảng: nghĩa là mạng được hỗ trợ; nếu nền tảng đích không hỗ trợ mạng rút tiền của bạn, thì không thể truy xuất tài sản.",
    "tips3": "2. Mạng nạp tiền của bạn và nền tảng mục tiêu giống nhau; nếu bạn chọn địa chỉ mục tiêu là mạng Ethereum, nhưng người nạp tiền chọn chuỗi thông minh TRC20, bạn có thể không truy xuất được tài sản kỹ thuật số của mình.",
    "tips4": "3. Đảm bảo rằng địa chỉ và số tiền của bạn là chính xác trước khi nạp tiền.",
    "tips5": "Nhắc nhở: Do tính ẩn danh và tính riêng tư của mạng khối, một khi bạn nhập sai thông tin, bạn sẽ mất tài sản tương ứng. Vui lòng kiểm tra kỹ địa chỉ và số lượng nạp tiền của bạn"
  },
  "tibi": {
    "title": "Rút",
    "tbjl": "Hồ sơ rút tiền",
    "t1": "Địa chỉ rút tiền",
    "t2": "Vui lòng nhập địa chỉ rút tiền",
    "t3": "Số lượng rút",
    "qsrtbsl": "Vui lòng nhập số lượng của tiền tệ sẽ rút",
    "t4": "Tối thiểu",
    "t5": "Mật khẩu giao dịch",
    "t6": "Vui lòng nhập mật khẩu giao dịch",
    "t7": "Phí",
    "t8": "Số tiền đến",
    "t9": "OK",
    "sc": "Xóa",
    "bj": "Chỉnh sửa",
    "bq": "Thẻ (Ghi nhớ)",
    "qsrbq": "Vui lòng nhập thẻ",
    "yhktx": "Rút qua thẻ ngân hàng",
    "yhmc": "Tên ngân hàng",
    "qsryhmc": "Vui lòng nhập tên ngân hàng",
    "yhzh": "Tài khoản ngân hàng",
    "qsryhzh": "Vui lòng nhập số tài khoản ngân hàng",
    "gjhkdm": "Mã SWIFT",
    "qsrgjhkdm": "Vui lòng nhập mã SWIFT",
    "yhdz": "Địa chỉ ngân hàng",
    "qsryhdz": "Vui lòng nhập địa chỉ ngân hàng",
    "skrxm": "Tên người hưởng",
    "qsrskrxm": "Vui lòng nhập tên người hưởng",
    "skrdh": "Số điện thoại của người hưởng",
    "qsrskrdh": "Vui lòng nhập số điện thoại của người hưởng",
    "skrdz": "Địa chỉ của người hưởng",
    "qsrskrdz": "Vui lòng nhập địa chỉ của người hưởng"
  },
  "huazhuan": {
    "t4": "Vui lòng nhập số tiền",
    "ky": "Khả dụng",
    "t10": "OK"
  },
  "banner": {
    "title": "Chi tiết"
  },
  "download": {
    "t1": "giao dịch, ở mọi nơi",
    "xz": "Tải về"
  },
  "xgdlmm": {
    "title": "Sửa đổi mật khẩu đăng nhập",
    "zh": "Tài khoản",
    "yzm": "Mã xác minh",
    "yzmts": "mã xác nhận",
    "hqyzm": "Nhận CAPTCHA",
    "mm": "Mật khẩu",
    "qrmm": "Xác nhận mật khẩu",
    "qr": "Xác nhận",
    "zhts":"Điện thoại di động hoặc email",
    "mmts":"Mật khẩu là tổ hợp gồm 6-12 chữ số và chữ cái"
  },
  "sztkmm": {
    "title": "Đặt mật khẩu rút tiền",
    "dlmm": "Mật khẩu đăng nhập ",
    "dlmmts": "Vui lòng nhập mật khẩu đăng nhập",
    "xmm": "Mật khẩu mới",
    "mmts": "Mật khẩu gồm 6 chữ số",
    "qrmm": "Xác nhận mật khẩu",
    "qr": "Xác nhận",
    "qd": "OK",
    "sztkts": "Mẹo: Vui lòng truy cập Trung tâm Bảo mật để đặt mật khẩu giao dịch"
  },
  "rule": {
    "title": "Quy định của sự kiện",
    "title2": "Quy định",
    "title3": "Sự kiện"
  },
  "news": {
    "title": "Tin nhắn của tôi",
    "ckxq": "Xem chi tiết",
    "gg": "Thông báo"
  },
  "search": {
    "qx": "Hủy"
  },
  "wdtg": {
    "wdyqlj": "Liên kết mời của tôi",
    "wdyqm": "Mã mời của tôi",
    "schbyq": "Tạo thư mời bằng áp phích",
    "ljtgsy": "Tổng doanh thu",
    "tkrs": "Số lượng thư mời",
    "ljyj": "Hoa hồng tích lũy",
    "yjmx": "Chi tiết tiền hoa hồng",
    "ljyjjl": "Phần thưởng hoa hồng tích lũy (USDT)",
    "ljsy": "Tổng doanh thu",
    "ljyqjl": "Phần thưởng thư mời tích lũy (USTD)",
    "fxd": "Chia sẻ đến",
    "bctp": "Lưu ảnh",
    "qx": "Hủy",
    "t3": "Nhận diện ảnh hoặc quét"
  },
  "bzhl": {
    "title": "Cổ tức",
    "gz": "Quy định",
    "tgdd": "Lệnh ký quỹ",
    "zztgdzj": "Quỹ giám hộ",
    "yjjrsy": "Thu nhập hôm nay",
    "ljsy": "Tổng doanh thu",
    "tgzdd": "Lệnh giám hộ",
    "cljxcp": "Sản phẩm chiến dịch chiến lược",
    "dbxe": "Hạn mức đơn",
    "rsyl": "Lợi suất hàng ngày",
    "zq": "Chu kỳ",
    "qmr": "Mua ngay",
    "bbzhzc": "Tài sản của tài khoản",
    "dd": "Lệnh",
    "buy": "Mua",
    "jxcp": "Sản phẩm nổi bật",
    "ckdd": "Lệnh kiểm tra",
    "gd": "Xem thêm",
    "xzbzts": "Đơn giản và an toàn. Cổ tức có thể được chọn bằng nhiều loại tiền tệ",
    "qtbz": "Các loại tiền khác"
  },
  "bzhlgm": {
    "qtzq": "Chu kỳ 7 ngày USDT",
    "rsyl": "Lợi suất hàng ngày",
    "lczq": "Chu kỳ tài chính",
    "dbxe": "Hạn mức đơn",
    "pxsj": "Thời gian thanh toán cổ tức",
    "mr": "Hàng ngày",
    "dqfh": "Hoàn trả khi đến hạn",
    "tgzj": "Vốn chủ sở hữu giám hộ",
    "tqsh": "Đổi sớm",
    "yjsy": "Thu nhập dự kiến (USDT)",
    "kyzc": "Tài sản khả dụng(USDT)",
    "cpjs": "Về sản phẩm của chúng tôi",
    "tgje": "Số tiền giám hộ",
    "qsrtgje": "Vui lòng nhập số tiền giám hộ",
    "qb": "Tất cả các",
    "rm": "Mua ngay",
    "cpzq": "Chu kỳ sản phẩm",
    "gz": "Hiểu rõ quy định và lợi ích"
  },
  "bzhlwdtg": {
    "title": "Trạng thái lệnh",
    "tgz": "Giám hộ",
    "ywc": "Đã hoàn tất",
    "ysh": "Đã đổi",
    "tgje": "Số tiền giám hộ/Thời gian giám hộ",
    "rsyl": "Lợi suất hàng ngày",
    "yhl": "Đã có lãi",
    "xdsj": "Thời gian đặt lệnh",
    "sh": "Đổi",
    "ddxq": "Chi tiết lệnh",
    "ddh": "Mã số lệnh"
  },
  "bzjj": {
    "t1": "Thu nhập mỗi ngày",
    "cpld": "Những điểm nổi bật của sản phẩm",
    "scsq": "Ký quỹ & lấy về bất kỳ lúc nào",
    "pxzq": "Chu kỳ cổ tức",
    "mtxf": "Phân phối hàng ngày",
    "hqlx": "Lãi suất hiện thời",
    "zj": "Tài trợ 100%",
    "aqbz": "Bảo mật",
    "jjrsy": "Thu nhập vào ngày nghỉ lễ",
    "sybjd": "Lợi nhuận liên tục",
    "bjd": "Không gián đoạn",
    "cgcrh": "Sau khi ký quỹ thành công",
    "dtqx": "Giá trị lãi suất theo ngày",
    "jglz": "Ví dụ",
    "syjs": "Tính toán doanh thu",
    "cont2": "Tối thiểu: 10000U x 0,3%=30U",
    "cont3": "Tối đa: 10000U x 0,5%=50U",
    "gywyj": "Về thiệt hại thanh khoản",
    "wycy": "Tôi muốn tham gia"
  },
  "zyzs": {
    "title": "Chốt lãi & cắt lỗ",
    "zy": "Chốt lãi",
    "zs": "Cắt lỗ",
    "qsrzyjg": "Vui lòng nhập giá chốt lãi",
    "qsrzsjg": "Vui lòng nhập giá cắt lỗ",
    "scjg": "Giá thị trường",
    "wxts": "Lời nhắc:",
    "qr": "Xác nhận"
  },
  "bbjy": {
    "mr": "Mua",
    "mc": "Bán",
    "mai": "Mua",
    "sell": "Bán",
    "xj": "Giới hạn",
    "sj": "Giá thị trường",
    "pk": "Điều bất lợi",
    "jg": "Giá",
    "sl": "Số lượng",
    "mrl": "Khối lượng mua",
    "ss": "Số lượng",
    "mcl": "Khối lượng bán",
    "ky": "Khả dụng",
    "km": "Khả dụng",
    "ksell": "Có thể mua bán",
    "jye": "Giao dịch",
    "dqwt": "Lệnh mở",
    "lswt": "Hoa hồng lịch sử",
    "jj": "Thông tin",
    "wtzl": "Toàn bộ",
    "wtjg": "Giá hoa hồng",
    "ycjl": "Khối lượng giao dịch hoàn tất",
    "cjjj": "Mức giá giao dịch trung bình",
    "cd": "Rút tiền",
    "xd": "Đặt một lệnh",
    "ywc": "Đã hoàn tất",
    "ycd": "Đã rút",
    "wqcj": "Giao dịch hoàn tất",
    "zx": "Tùy chọn",
    "scjg": "Giá thị trường",
    "fhsj": "Thời gian công bố",
    "fhsl": "Mã số phát hành",
    "bps": "Sách trắng",
    "gw": "Trang web chính thức",
    "qx": "Hủy"
  },
  "hyjy": {
    "mai": "Mua",
    "sell": "Bán",
    "kc": "Vị thế mở",
    "pc": "Đóng",
    "cc": "Vị thế",
    "kp": "Đóng",
    "kpc": "Đóng vị thế ngắn hạn",
    "kcc": "Vị thế",
    "kkd": "Mở vị thế dài hạn",
    "kpd": "Đóng vị thế dài hạn",
    "kkk": "Mở vị thế ngắn hạn",
    "xj": "Giới hạn",
    "sj": "Giá thị trường",
    "xjwt": "Lệnh giới hạn",
    "sjwt": "Giá thị trường",
    "pk": "Điều bất lợi",
    "jg": "Giá",
    "sl": "Số lượng",
    "gg": "Đòn bẩy",
    "tzgg": "Điều chỉnh đòn bẩy",
    "ggbs": "Đòn bẩy",
    "mrl": "Khối lượng mua",
    "ky": "Khả dụng",
    "jye": "Giao dịch",
    "dqwt": "Lệnh mở",
    "lswt": "Hoa hồng lịch sử",
    "ptwt": "Hoa hồng thông thường",
    "dqwtmr": "Lệnh hiện thời (Mua)",
    "dqwtmc": "Lệnh hiện thời (Bán)    ",
    "hywt": "Hoa hồng theo hợp đồng",
    "jj": "Thông tin",
    "wtzl": "Toàn bộ",
    "wtjg": "Giá hoa hồng",
    "ycjl": "Khối lượng giao dịch hoàn tất",
    "cjjj": "Mức giá giao dịch trung bình",
    "cd": "Rút tiền",
    "xd": "Đặt một lệnh",
    "wqcj": "Giao dịch hoàn tất",
    "ywc": "Đã hoàn tất",
    "ycd": "Đã rút",
    "zx": "Tùy chọn",
    "scjg": "Giá thị trường",
    "fhsj": "Thời gian công bố",
    "fhsl": "Mã số phát hành",
    "bps": "Sách trắng",
    "gw": "Trang web chính thức",
    "mrzd": "Mua dài hạn",
    "mrpk": "Mua ngắn hạn ",
    "mczk": "Bán ngắn hạn ",
    "mcpd": "Bán dài hạn",
    "mrkdkz": "Mua khi mở (tăng giá)",
    "mrpkkz": "Mua khi đóng (tăng giá)",
    "mckkkd": "Bán khi mở (giảm giá)",
    "mcpdkd": "Bán khi đóng (giảm giá)",
    "yxhy": "Hợp đồng vĩnh viễn",
    "dc": "Vị thế dài hạn",
    "syl": "Lợi suất",
    "bzjl": "Tỷ lệ ký quỹ",
    "tzbzj": "Điều chỉnh ký quỹ",
    "zyzs": "Chốt lãi & cắt lỗ",
    "zhang": "Số lượng",
    "qblx": "Tất cả các loại",
    "qb": "Tất cả các",
    "ccjg": "Mức giá vị thế",
    "ccsl": "Số lượng vị thế",
    "yk": "Lãi và lỗ",
    "ccsj": "Thời gian của vị thế",
    "zy": "Chốt lãi",
    "zs": "Cắt lỗ",
    "zje": "Tổng tiền",
    "kcs": "Số lượng vị thế mở",
    "kcjg": "Mức giá vị thế mở",
    "ss": "Lô",
    "hand": "1 lô =",
    "qx": "Hủy",
    "qr": "Xác nhận",
    "qbcd":"Hủy tất cả các đơn đặt hàng"
  },
  "kxt": {
    "gao":"H",
    "di":"L",
    "wtgd": "Lệnh đang chờ",
    "cj": "Thỏa thuận",
    "jj": "Thông tin",
    "sj": "Thời gian",
    "fx": "Xu hướng",
    "jg": "Giá",
    "sl": "Số lượng",
    "mr": "Mua",
    "mc": "Bán",
    "mp": "Đấu thầu",
    "sp": "Đang bán",
    "slb": "Số lượng",
    "fhsj": "Thời gian công bố",
    "fhsl": "Mã số phát hành",
    "bps": "Sách trắng",
    "gw": "Trang web chính thức",
    "fz":"min",
    "xs":"hour",
    "tian":"day",
    "zhou":"week",
    "yue":"month",
    "gd":"More",
    "ft": "Ảnh phụ",
    "zt": "Ảnh chính",
    "sdt": "Độ sâu",
    "zx": "Tùy chọn",
    "djck": "Bấm để xem"
  },
  "zhjl": {
    "cbtb": "Ký quỹ & Rút tiền",
    "jymx": "Chi tiết giao dịch",
    "tgyj": "Hoa hồng khuyến mại",
    "wwc": "Hoàn tác",
    "ywc": "Đã hoàn tất"
  },
  "zwsj": {
    "title": "Không có dữ liệu"
  },
  "bzxz": {
    "title": "Lựa chọn tiền tệ"
  },
  "jghy": {
    "jghy": "Hoán đổi",
    "yxhy": "vĩnh viễn",
    "mz": "Tăng giá",
    "md": "Giảm giá",
    "gmj": "Giá mua",
    "jsj": "Giá thanh toán",
    "xj": "Giá hiện thời",
    "fx": "Xu hướng",
    "sl": "Số lượng",
    "jgsj": "Thời gian giao",
    "gb": "Đóng",
    "jxxd": "Tiếp tục đặt lệnh",
    "cclb": "Danh sách lệnh",
    "zc": "Hiện thời",
    "lscc": "Lịch sử",
    "qblx": "Tất cả các loại",
    "yk": "Lãi và lỗ",
    "ddqr": "Xác nhận lệnh",
    "dqsj": "Thời gian hết hạn",
    "jssj": "Thời gian giao",
    "sy": "Lãi",
    "tzje": "Mức giá đầu tư",
    "zdje": "Giá thấp nhất 0",
    "kyye": "Thăng bằng: ",
    "kyye2": "Thăng bằng",
    "sxf": "Phí: ",
    "sxfl": "Phí",
    "jypz": "Tên",
    "jyfx": "Xu hướng",
    "qrxd": "Xác nhận",
    "dqye": "Số dư hiện thời"
  },
  "kjmb": {
    "title": "Tiền điện tử",
    "gm": "Mua USDT",
    "wxts": "Lời nhắc:",
    "copy": "Sao chép",
    "ljmb": "Mua tiền điện tử",
    "qx": "Hủy",
    "gmsl": "Số lượng mua",
    "cssl": "Số lượng đã bán",
    "qsrgmsl": "Vui lòng nhập số lượng mua",
    "qsrcssl": "Vui lòng nhập số lượng bán",
    "jg": "Giá",
    "fzcg": "Sao chép thành công"
  },
  "tips": {
    "jymm": "Mật khẩu giao dịch",
    "szjymm": "Đặt mật khẩu rút tiền",
    "qsrjymm": "Vui lòng nhập mật khẩu giao dịch",
    "jymmts": "Vui lòng truy cập Trung tâm Bảo mật để đặt mật khẩu giao dịch"
  },
  "xyf":{
    "title": "Điểm tín dụng",
    "pgsj": "Thời gian đánh giá"
  },
  "dzrz":{
    "title": "Xác thực địa chỉ",
    "sdddz":"Địa chỉ hóa đơn tiện ích",
    "tpsc": "tải hình ảnh Bill",
    "ts": "Nhắc nhở: Bạn cần điền thông tin địa chỉ và gửi hóa đơn điện nước hoặc hóa đơn địa chỉ băng thông rộng",
    "tips":"Bạn cần điền thông tin địa chỉ và gửi hóa đơn điện nước hoặc hóa đơn địa chỉ băng thông rộng",
    "qsczdtp":"tải hình ảnh Bill"
  },
  "newReg":{
    "sjh": "điện thoại di động",
    "yx": "e-mail",
    "yqm": "Mã mời",
    "yqm2": "Mã lời mời (tùy chọn)",
    "cjzh": "Tạo tài khoản",
    "sysjhzyx": "Đăng ký bằng số điện thoại di động / email",
    "sj": "Di động",
    "yhxy": "&lt;Thoản thuận người dung&gt;",
    "yhxy2": "Tôi đã đọc và đồng ý với &lt;Thoản thuận người dung&gt;"
  },
  "mbwt":{
    "title": "Vấn đề An ninh",
    "mbwt": "Vấn đề An ninh",
    "qtxda": "Vui lòng trả lời",
    "qsrxmm": "Vui lòng nhập mật khẩu mới",
    "sydqmmcz": "Sử dụng Đặt lại Mật khẩu Hiện tại",
    "zhmm": "Vấn đề bảo mật Lấy lại mật khẩu",
    "ysz": "Cài đặt",
    "tg": "Bỏ qua",
    "tj": "Gửi đi",
    "zyts": "Quan trọng:",
    "zytsCont": "Không tiết lộ câu trả lời bí mật và mã xác minh, đồng thời lưu ý vấn đề bảo mật, điều này sẽ giúp bạn lấy lại mật khẩu của mình"
  },
  "xbsg":{
    "title": "Tiền xu mới",
    "wdsg": "Thông tin chi tiết",
    "scts": "Ngày nhốt: ",
    "sy": "còn lại",
    "ljsg": "Theo dõi ngay",
    "ysk": "Bán hết",
    "xzjdy": "Theo dõi ngay",
    "dy": "Đặt mua",
    "fxjg": "giá phát hành",
    "fxl": "Vòng tuần hoàn",
    "ssrq": "Ngày niêm yết",
    "yxqx": "Thời gian hiệu lực",
    "qsrsl": "Vui lòng nhập số tiền",
    "syl": "còn lại",
    "sgrq": "đặt mua",
    "sgsl": "Số lượng",
    "bz": "Đồng tiền",
    "yebz": "Số dư USDT không đủ",
    "tgsl": "Vượt qua Qty",
    "shz": "đang xem xét",
    "wtg": "Không vượt qua",
    "ytg": "thông qua"
  },
  "wydb":{
    "title": "Vay",
    "db": "Vay",
    "dbz": "Vay",
    "jl": "ghi lại",
    "jdzq": "vay (ngày)",
    "qhk": "Trả lại",
    "ljdb": "Tích lũy (usdt)",
    "dhkbs" :"Trong khi chờ thanh toán",
    "jkje": "số tiền (usdt)",
    "qsrje": "Vui lòng nhập số tiền",
    "rll": "Lãi suất hàng ngày",
    "hkfs": "Trả nợ",
    "dqych": "Hết hạn",
    "lx": "Quan tâm",
    "fkjg": "Người cho vay",
    "tpsc": "Khoản vay tín dụng (tải lên hình ảnh)",
    "fwxx": "Thông tin nhà ở",
    "srzm": "Chứng minh thu nhập (mối quan hệ việc làm)",
    "yhmx": "Sao kê ngân hàng",
    "zjz": "Ảnh ID",
    "yd": "Tôi đã đọc và đồng ý",
    "xy": "Đăng ký hợp đồng vay",
    "sqdb": "đăng ký chuỗi cho vay",
    "gb": "Khép kín",
    "qd": "VÂNG",
    "ts": "Vui lòng kiểm tra Đăng ký hợp đồng vay",
    "dbjl": "ghi lại",
    "hkhth": "Mã đặt hàng",
    "wsh": "Chưa được đánh giá",
    "yfk": "Tiền vay",
    "sqrq": "thời gian nộp đơn",
    "zq": "xe đạp",
    "dbsl": "số lượng",
    "zhke": "Tổng tiền thanh toán",
    "yhkxq": "Chi tiết trả nợ",
    "bqyhk": "Phải trả trong kỳ hiện tại(USDT)",
    "hktips": "Hãy đảm bảo số dư còn đủ, nếu số dư không đủ vui lòng nạp tiền trước rồi hoàn trả",
    "bj": "Hiệu trưởng",
    "jie": "Vay",
    "ljhk": "Trả nợ ngay lập tức",
    "qcz": "Gửi tiền",
    "yebzqxcz": "Không đủ số dư, vui lòng nạp tiền trước và sau đó hoàn trả",
    "znj": "phí thanh toán chậm",
    "yqts": "Ngày quá hạn"
  },
  "hkxq":{
    "dd":"Gọi món",
    "fzhkdz":"Sao chép địa chỉ trả nợ",
    "hkxq": "Chi tiết trả nợ",
    "zlx": "tổng lãi",
    "zhk": "tổng số tiền hoàn trả",
    "hkjg": "cơ quan trả nợ",
    "qschkpz": "Vui lòng tải lên chứng chỉ hoàn trả",
    "hkpz": "giấy chứng nhận trả nợ"
  },
  "bbjyNew":{
    "jylx": "Các loại",
    "jyze": "Số lượng"
  },
  "indexNew":{
    "title": "Thêm TokenSwap vào giao diện chính",
    "t1": "Truy cập nhanh vào trải nghiệm toàn màn hình",
    "t2": "Nhấp vào thanh công cụ bên dưới",
    "t3": "và chọn",
    "t4": "Thêm vào màn hình chính",
    "t5": "Thêm vào trải nghiệm máy tính để bàn phiên bản đầy đủ của TokenSwap",
    "t6": "Thêm vào mục ưa thích",
    "t7": "Tìm trên trang"
  },
  "bind":{
    "title": "email",
    "ybd": "Ràng buộc",
    "wbd": "Không ràng buộc",
    "yrz": "Đã xác minh",
    "wrz": "Chưa xác minh",
    "ts": "Để bảo vệ tài khoản của bạn, bạn nên liên kết một địa chỉ email",
    "qsryxdz": "địa chỉ email"
  },
  "status":{
    "statusText": ['sự thất bại','Đang chờ được xử lý','sự thành công'],
 },
 "tipsNew":{
   "wjmmts": "Khôi phục mật khẩu bằng mã xác minh",
   "qscpztp": "Tải lên hình ảnh phiếu thưởng",
   "emailgsts": "Vui lòng nhập email hợp lệ",
   "telgsts": "Số điện thoại di động không chính xác",
   "lcmmbyz": "Vui lòng xác nhận mật khẩu của bạn",
   "zdsl": "Tối thiểu ",
   "sldydy": "Số lượng lớn hơn hoặc bằng",
   "zxtzsl": "Tối thiểu ",
   "ddz": "Đang chờ đợi",
   "xs": "Giờ",
   "min": "Số tiền tối thiểu ",
   "max": "Số tiền tối đa ",
   "yebz": "Thiếu cân bằng",
   "qsrss": "Vui lòng nhập lô",
   "zdss": "Số lô tối thiểu",
   "yjj": "từ chối",
   "shz": "chuộc lỗi",
   "zwkfcz": "Đơn vị tiền tệ này chưa mở để nạp tiền",
   "jiaoge": "Giao hàng",
    "zhang": "tăng",
    "die": "rơi",
    "cjxnzh": "Tạo tài khoản ảo"
 },
 "langNew2":{
  "flzq": "Trung tâm phần thưởng",
  "qdjl": "Đăng nhập phần thưởng",
  "mrqdjl": "Phần thưởng đăng nhập hàng ngày",
  "qd": "Đăng nhập",
  "yqd": "Đăng nhập",
  "hdgz": "Thể lệ sự kiện",
  "qdjl2": "Nhật ký nhập cảnh",
  "qdcg": "Đăng nhập thành công",
  "yhd": "Đã nhận được",
  "lq": "Nhận",
  "dyt": "Ngày 1",
  "det": "Ngày 2",
  "dst": "Ngày 3",
  "dsit": "Ngày 4",
  "dwt": "Ngày 5",
  "dlt": "Ngày 6",
  "dqt": "Ngày 7",
  "jxz": "đang tiến hành"
},
"langNew":{
  "kp": "Khai mạc",
  "zuoshou": "nhận được ngày hôm qua",
  "zg": "cao nhất",
  "zd": "thấp nhất",
  "dqjg": "Giá hiện tại",
  "pcjg": "Giá đóng cửa",
  "gd": "danh sách hàng chờ",
  "gdj": "Giá đặt hàng đang chờ xử lý",
  "gdjg": "Giá đặt hàng đang chờ xử lý",
  "xfbzj": "Yêu cầu đặt cọc bảo đảm: ",
  "ksrfw": "Phạm vi đầu vào khả dụng: ",
  "shou": "Rất nhiều",
  "fdjyk": "lãi và lỗ ròng thả nổi",
  "pcsl": "Đóng số lượng",
  "cx": "thu hồi",
  "qrpc": "Xác nhận đóng vị thế",
  "sx": "lọc",
  "cz": "cài lại",
  "zdl": "biết",
  "kccg": "Đã mở thành công một vị thế!",
  "xzfx": "chọn hướng",
  "lx": "kiểu",
  "xgcc": "sửa đổi vị trí",
  "szzyzs": "Đặt dừng lợi nhuận và dừng lỗ",
  "szhb": "tiền điện tử",
  "gjs": "Kim loại",
  "yy": "thô",
  "jy": "Buôn bán",
  "jmhb": "tiền điện tử",
  "gdsj": "Thời gian đặt hàng đang chờ xử lý",
  "gdsl": "Số lượng đặt hàng đang chờ xử lý",
  "fs": "time"
 }
}



// WEBPACK FOOTER //
// ./src/utils/lang/vn.js